import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import './styles/CustomStarIcon.css';

const CustomStarIcon = ( { setRating, className, initialRating = 0 } ) => {
    const [rating, setRatingStars] = useState(initialRating);
    const [hover, setHover] = useState(null);

    return (
        <div className={className}>
            {[... Array(5)].map((star, i) => {
                const ratingValue = i + 1;

                return (
                    <label key={i}>
                        <input 
                        type="radio" 
                        name="rating"
                        value={ratingValue} 
                        onClick={() => {setRatingStars(ratingValue); setRating(ratingValue); }}
                        />
                        <FaStar
                        className='star'
                        size={50} // Adjusted size - between mobile and desktop
                        color={ ratingValue <= ( hover || rating ) ? '#ffc107' : '#e4e5e9'}
                        onMouseEnter={() => setHover(ratingValue)}
                        onMouseLeave={() => setHover(null)}
                        />
                    </label>
                );
            })}
        </div>
    );
};

export default CustomStarIcon;